import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import "../../estilo/App.css";
import ModalAgregar from "../modales/ModalAgregar";

const BtnAgregar = ({ table, funcSenal }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box>
      <Box>
        <Button sx={{ mt: 2 }} variant="outlined" onClick={handleOpenModal}>
          Agregar
        </Button>
      </Box>
      <ModalAgregar open={openModal} handleClose={handleCloseModal} fetchData={funcSenal} tabla={table} />
    </Box>
  );
};

export default BtnAgregar;
